import Button from '@mui/material/Button';
import React, { useState } from 'react';
import { PolicyContext } from '../context/policy';
import DefaultDialog from './DefaultDialog';

interface Props {
	paymentLocator: string;
	displayId: string;
	onReverse: (locator: string) => void;
}

const ReversePaymentModal = (props: Props) => {
	const { paymentLocator, displayId, onReverse } = props;

	const [isOpen, setIsOpen] = useState(false);

	const close = () => {
		setIsOpen(false);
	};

	const open = () => setIsOpen(true);

	const reversePayment = () => {
		onReverse(paymentLocator);
		close();
	};

	const heading = `Reverse Payment ${displayId}`;
	const actions = [
		{ text: 'Reverse Payment', onClick: reversePayment },
		{ text: 'Cancel', onClick: close },
	];

	return (
		<>
			<Button
				variant='outlined'
				color='primary'
				onClick={open}
				data-testid='ReversePaymentModal__Button--Open'
			>
				Reverse Payment
			</Button>
			<DefaultDialog
				actions={actions}
				open={isOpen}
				onClose={close}
				title={heading}
			>
				Are you sure you want to reverse this payment?
			</DefaultDialog>
		</>
	);
};

function withContext(Component: any) {
	return (props: Omit<Props, 'policyData'>) => (
		<PolicyContext.Consumer>
			{(policyData) => <Component {...props} policyData={policyData} />}
		</PolicyContext.Consumer>
	);
}

export default withContext(ReversePaymentModal);
